import { theme } from '@hhgtech/hhg-components'

type Props = {
  color?: string
  size?: number
}

const RecalculationIcon = ({
  size = 18,
  color = theme.colors.white,
}: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.51345 15.6233C7.28653 15.958 8.11537 16.1253 8.99998 16.1253C9.88459 16.1253 10.7134 15.958 11.4865 15.6233C12.2596 15.2887 12.9336 14.8339 13.5086 14.2589C14.0836 13.6839 14.5384 13.0099 14.873 12.2368C15.2077 11.4638 15.375 10.6349 15.375 9.7503C15.375 8.86568 15.2077 8.03684 14.873 7.26377C14.5384 6.49069 14.0836 5.81665 13.5086 5.24165C12.9336 4.66667 12.2596 4.21187 11.4865 3.87725C10.7134 3.54263 9.88459 3.37532 8.99998 3.37532H8.80093L9.61153 2.56473C9.72787 2.4484 9.78412 2.31667 9.78028 2.16956C9.77643 2.02245 9.72018 1.89072 9.61153 1.77437C9.49518 1.65803 9.36033 1.59913 9.20696 1.59768C9.0536 1.59625 8.92116 1.6513 8.80963 1.76283L7.10916 3.45609C6.97358 3.59167 6.90579 3.74983 6.90579 3.9306C6.90579 4.11137 6.97358 4.26955 7.10916 4.40512L8.79519 6.09836C8.91154 6.21471 9.04519 6.27096 9.19614 6.26711C9.34711 6.26326 9.48076 6.20317 9.59709 6.08683C9.70576 5.97048 9.76081 5.83755 9.76224 5.68803C9.76368 5.53852 9.70863 5.408 9.59709 5.29646L8.80093 4.5003H8.99998C10.4625 4.5003 11.7031 5.00967 12.7219 6.02842C13.7406 7.04717 14.25 8.2878 14.25 9.7503C14.25 11.2128 13.7406 12.4534 12.7219 13.4722C11.7031 14.4909 10.4625 15.0003 8.99998 15.0003C7.53748 15.0003 6.29686 14.4909 5.27811 13.4722C4.25936 12.4534 3.74998 11.2128 3.74998 9.7503C3.74998 9.59068 3.69614 9.45703 3.58845 9.34935C3.48076 9.24166 3.34711 9.18782 3.1875 9.18782C3.02789 9.18782 2.89424 9.24166 2.78655 9.34935C2.67885 9.45703 2.625 9.59068 2.625 9.7503C2.625 10.6349 2.79231 11.4638 3.12694 12.2368C3.46155 13.0099 3.91635 13.6839 4.49134 14.2589C5.06634 14.8339 5.74038 15.2887 6.51345 15.6233Z"
        fill={color}
      />
    </svg>
  )
}

export default RecalculationIcon
